import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SignalStates } from 'src/app/Models/MagnituderAlerts';
import { MagnituderAlertsService } from 'src/app/Services/MagnituderAlertsService';
import { DrawingService } from '../../app/Services/DrawingService';


@Component({
  selector: 'app-signals-visualization',
  templateUrl: './signals-visualization.component.html',
  styleUrls: ['./signals-visualization.component.scss']
})
export class SignalsVisualizationComponent implements OnInit, AfterViewInit {

  private _foregroundDiffStyle;
  public get foregroundDiffStyle() {
    return this._foregroundDiffStyle;
  }
  public set foregroundDiffStyle(value) {
    this._foregroundDiffStyle = value;
  }
  private _backgorundDiffStyle;
  public get backgorundDiffStyle() {
    return this._backgorundDiffStyle;
  }
  public set backgorundDiffStyle(value) {
    this._backgorundDiffStyle = value;
  }

  constructor(public magnituderAlerts: MagnituderAlertsService, public drawingService: DrawingService) {

    this.magnituderAlerts.newForegroundDiffStateObserver.subscribe((v) => {

      if (v == "red") {
        this.foregroundDiffStyle = { backgroundColor: "red" }
      }
      else {
        this.foregroundDiffStyle = { backgroundColor: "green" }
      }
    }
    )

    this.magnituderAlerts.newBackgroundDiffStateObserver.subscribe((v) => {
      if (v == "red") {
        this.backgorundDiffStyle = { backgroundColor: "red" }
      }
      else {
        this.backgorundDiffStyle = { backgroundColor: "green" }
      }
    }
    )


  }
  ngAfterViewInit(): void {
    if (this.drawingService.alertsForegroundMagnituder) {

      if (this.drawingService.alertsForegroundMagnituder.currentState == SignalStates.BUY) {
        this.foregroundDiffStyle = { backgroundColor: "red" }
      }
      else {
        this.foregroundDiffStyle = { backgroundColor: "green" }
      }
    }
    if (this.drawingService.alertsBackgroundMagnituder) {


      if (this.drawingService.alertsBackgroundMagnituder.currentState == SignalStates.BUY) {
        this.backgorundDiffStyle = { backgroundColor: "red" }
      }
      else {
        this.backgorundDiffStyle = { backgroundColor: "green" }
      }
    }
  }

  public get backgroundTimer()
  {

    if(this.drawingService.alertsBackgroundMagnituder&&this.drawingService.alertsBackgroundMagnituder.canCheckSignal)
    {
      return (this.magnituderAlerts.greyTime=='')?"":this.magnituderAlerts.greyTime;
    }

    return "";
  }
  public get foregroundTimer()
  {

    if(this.drawingService.alertsForegroundMagnituder&&this.drawingService.alertsForegroundMagnituder.canCheckSignal)
    {
      return (this.magnituderAlerts.violetTime=='')?"":this.magnituderAlerts.violetTime;
    }

    return "";
  }

  public  format(time) {
    // Hours, minutes and seconds
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = ~~time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}



  ngOnInit() {

  }



}
